const API_URL = '/api/library/'

export const initLibrary = () => {
  const el = document.querySelector('[data-library]')
  if (!el) return

  const tbody = el.querySelector('[data-library-tbody]')
  const tableEl = el.querySelector('[data-library-table]')
  const cardsEl = el.querySelector('[data-library-cards]')
  const loadMoreWrap = el.querySelector('[data-library-load-more]')
  const loadMoreBtn = loadMoreWrap?.querySelector('button')
  const loadingEl = el.querySelector('[data-library-loading]')
  const emptyEl = el.querySelector('[data-library-empty]')

  let nextPage = null
  let loading = false

  const getFilters = () => {
    const params = new URLSearchParams(window.location.search)
    return {
      categorie: params.get('categorie') || '',
      tip: params.get('tip') || '',
      interesse: params.get('interesse') || '',
      q: params.get('q') || '',
    }
  }

  const setLoading = (state) => {
    loading = state
    if (loadingEl) loadingEl.hidden = !state
    if (loadMoreBtn) loadMoreBtn.disabled = state
  }

  const updateVisibility = () => {
    const hasRows = tbody && tbody.rows.length > 0
    const hasCards = cardsEl && cardsEl.children.length > 0
    const hasContent = hasRows || hasCards

    if (tableEl) tableEl.hidden = !hasRows
    if (emptyEl) emptyEl.hidden = hasContent
  }

  const fetchPage = async (page = 1) => {
    if (loading) return
    setLoading(true)

    const { categorie, tip, interesse, q } = getFilters()
    const params = new URLSearchParams({ page: String(page) })
    if (categorie) params.set('categorie', categorie)
    if (tip) params.set('tip', tip)
    if (interesse) params.set('interesse', interesse)
    if (q) params.set('q', q)

    try {
      const res = await fetch(`${API_URL}?${params}`)
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()

      if (tbody && data.rows_html) {
        tbody.insertAdjacentHTML('beforeend', data.rows_html)
      }
      if (cardsEl && data.cards_html) {
        cardsEl.insertAdjacentHTML('beforeend', data.cards_html)
      }

      nextPage = data.has_more ? data.next_page : null
      if (loadMoreWrap) loadMoreWrap.hidden = !data.has_more

      updateVisibility()
    } catch (err) {
      console.error('[library] fetch failed', err)
    } finally {
      setLoading(false)
    }
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      if (nextPage !== null) fetchPage(nextPage)
    })
  }

  fetchPage(1)
}
